import React from 'react';
import { Box } from 'components';
import { Date as DateWrapper } from 'apps/components/date';
import { RevisionItemStyled, RevisionTextStyled } from './revisionItem.styled';

interface RevisionItemProps {
  title?: string;
  selected?: boolean;
  userName?: string;
  date?: Date;
  unreadMessageCount?: number;
  onClick?: () => void;
}

const RevisionItem = ({
  unreadMessageCount,
  onClick,
  selected,
  title,
  userName,
  date,
}: RevisionItemProps) => {
  return (
    <RevisionItemStyled selected={selected} onClick={onClick}>
      <RevisionTextStyled>{title}</RevisionTextStyled>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <RevisionTextStyled>{unreadMessageCount}</RevisionTextStyled>
        <RevisionTextStyled>
          <DateWrapper value={date} />
          &nbsp; by &nbsp;
          {userName}
        </RevisionTextStyled>
      </Box>
    </RevisionItemStyled>
  );
};

export default RevisionItem;
